import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

const useDashboard = (): boolean => {
  const { abbrBrand, market } = useContext(BrandInfoContext);
  const dashBoardEnabled = useEnabledFeature(
    `cat-product-dashboard-${abbrBrand}-${market}`
  );

  const dashBoardExperimentEnabled = useEnabledSegment(`${abbrBrand}50`);

  return dashBoardEnabled && dashBoardExperimentEnabled;
};

export default useDashboard;
